// extracted by mini-css-extract-plugin
export default {"licensedEntity":"FinancialEstimates_licensedEntity__yOVFx","warning":"FinancialEstimates_warning__Di5lB"};